import { Text, View, TouchableOpacity } from 'react-native';
import Popup from 'reactjs-popup';
import { StyleSheet } from 'react-native';
import { colors } from '../colors/colors';
import { fontConfig } from '../fonts/fonts';
import _ from 'lodash';
import Icon from 'react-native-easy-icon';
import { hash, titleTruncate } from '@zonofi/common';

export const getTagItem = (
  mainText: string,
  truncate: number,
  enableEdit: boolean,
  isEdit?: boolean | string,
  onDelete?: () => void,
  customCloseIcon?: string
) => {
  const backGrounds = colors.tagColors;
  const bgColor = backGrounds[hash(mainText, backGrounds.length)];
  return (
    <View
      style={[
        {
          backgroundColor: bgColor.background,
          borderColor: 'transparent',
        },
        styles['tagContainer'],
        { height: 18, zIndex: 9 },
      ]}
    >
      {mainText?.length < 17 ? (
        <Text style={[styles['tagText'], { color: bgColor?.color }]}>
          {titleTruncate(mainText, truncate)}
        </Text>
      ) : (
        <Popup
          trigger={
            <Text style={[styles['tagText'], { color: bgColor?.color }]}>
              {titleTruncate(mainText ?? '-', 17)}
            </Text>
          }
          arrowStyle={{ color: 'transparent' }}
          on={['hover', 'focus']}
        >
          <Text
            style={[
              styles['tagText'],

              {
                color: bgColor?.color,
                padding: 2,
                paddingHorizontal: 3,
                borderRadius: 2,
                backgroundColor: bgColor.background,
                fontFamily: 'Segoe-UI-VF',
              },
            ]}
          >
            {mainText}
          </Text>
        </Popup>
      )}
      {isEdit &&
        (customCloseIcon ? (
          <img
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.();
            }}
            src={customCloseIcon}
            alt=""
            style={{
              marginLeft: '2px',
            }}
          />
        ) : (
          <TouchableOpacity
            style={[styles['circle'], { zIndex: 99997989987 }]}
            onPress={(e) => {
              onDelete && onDelete();
            }}
          >
            <Icon
              type="entypo"
              name="cross"
              size={12}
              color={colors.white.color}
            />
          </TouchableOpacity>
        ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tagContainer: {
    borderWidth: 0.5,
    borderRadius: 3,
    paddingHorizontal: 4,
    paddingVertical: 2,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 2,
    marginVertical: 3,
    alignItems: 'center',
  },
  tagText: {
    fontSize: 12,
    color: colors.white.color,
    lineHeight: 25,
    ...fontConfig.default.regular,
  },
  circle: {
    marginHorizontal: 5,
    height: 14,
    width: 14,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.manatee.color,
  },
});
